export default __webpack_public_path__ + "static/media/i_bus-low_pp.543f4360.svg";